import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    // padding: "12px",
    // maxHeight: "256px",
    // width: "100%",
    backgroundColor: theme.palette.white.main,
    display: "block",
  },
  nav: {
    padding: "12px",
    display: "inline-grid",
  },
  nav2: {
    padding: "12px",
    display: "inline-grid",
  },
  listItem: {
    color: theme.palette.secondary.main,
    padding: "12px",
    display: "block",
    "&:hover": {
      borderRadius: "4px",
      backgroundColor: theme.palette.gray2.main,
    },
  },
  text: {
    minWidth: "126px",
    fontSize: "12px",
  },
}));
